import { useState as e, useEffect as d } from "react";
const k = (t, n) => {
  const [c, h] = e(t);
  d(() => {
    h(t);
  }, [t]), d(() => {
    if (c) {
      if (c === window)
        return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
      {
        const a = new ResizeObserver(() => {
          n(c);
        });
        return a.observe(c, { box: "content-box" }), () => a.disconnect();
      }
    }
  }, [c, n]);
}, C = (t, n) => t || Math.max(Math.ceil(n / 2), 5), q = ({
  parentRef: t,
  size: n = 0,
  elementHeight: c,
  tolerance: h,
  minIndex: a = 0,
  minRows: v = 0,
  minViewportHeight: g
}) => {
  const [i, S] = e(n), [M, T] = e(), [o, z] = e(c), [m, H] = e(h), [b, L] = e(), [f, p] = e(), [B, I] = e(0), [O, V] = e(0), [D, y] = e(0);
  d(() => {
    var r;
    if (i) {
      const { height: l } = (r = t == null ? void 0 : t.current) == null ? void 0 : r.getBoundingClientRect(), s = Math.ceil(l / o) > v ? Math.ceil(l / o) : v, u = C(h, s), x = s === v ? s * c : l, E = i <= s ? "auto" : x;
      L(i * o), p(
        g != null && g > E ? g : E
      ), T(s + 2 * u), H(u);
    }
  }, [i, o, v, g]);
  const w = (r) => {
    const { scrollTop: l } = r.target, s = Math.min(
      a + Math.floor(
        (l - m * o) / o
      ),
      i
    );
    if (s < i) {
      const u = Math.max((s - a) * o, 0), x = Math.max(
        b - u - M * o,
        0
      );
      I(Math.max(s, 0)), y(x), V(u);
    }
  };
  return d(() => {
    const { current: r } = t ?? {};
    return w({ target: { scrollTop: 0 } }), r.addEventListener("scroll", w), () => r.removeEventListener("scroll", w);
  }, [b]), {
    setSize: S,
    setVirtualRowHeight: z,
    virtualRowHeight: o,
    virtualRows: M,
    initialIndex: B,
    topHeight: O,
    bottomHeight: D,
    totalHeight: b,
    viewportHeight: f
  };
};
export {
  q as a,
  k as u
};
